import { FooterWrapper } from './style';
import useMediaQuery from '@mui/material/useMediaQuery';

// Component
import Text from 'components/common/Text';
import Link from 'components/common/Link';
import Image from 'next/image';

// Libs
import Translation from 'libs/Translation';

const Footer = ({ webConfig }) => {
    const isMobile = useMediaQuery('(max-width:900px)');
    const medium = useMediaQuery('(max-width:1200px)');

    return (
        <FooterWrapper>
            {isMobile 
            ?
            <Image
                src="/nextasset/images/home/footer.png"
                alt=""
                width={900}
                height={550}
                className='img'
            />
            :
            <Image
                src="/nextasset/images/home/footer.png"
                alt=""
                width={2500}
                height={750}
                className='img'
            />
            }
            <div className='column-flex'>
                <Image
                    src="/nextasset/images/home/heart.png"
                    alt="heart-icon"
                    width={!medium ? 152 : 57}
                    height={!medium? 48 : 18}
                />
                <Text
                    className="title"
                >
                    {Translation.t('title.doctors-registration')}
                </Text>
                <Text
                    className="desc"
                >
                    {Translation.t('text.register-now')}
                </Text>
                <Link
                    className="link"
                    to="/register"
                    params={webConfig.lang !== 'fa' ? {lang: webConfig.lang} : {}}
                >
                    {Translation.t('label.register')}
                </Link>
            </div>
        </FooterWrapper>
    )
}
export default Footer;